module.exports = __webpack_public_path__ + "static/Support-4132fa5c99827700ebbc1cd9a26011a7.png";